var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1330_1615)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13,
    r: 12.5,
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2914 13.1841L18.1464 9.32907C18.3366 9.1218 18.4394 8.84909 18.4333 8.56787C18.4272 8.28665 18.3127 8.01865 18.1137 7.81982C17.9148 7.62098 17.6467 7.50668 17.3655 7.50076C17.0842 7.49485 16.8116 7.59778 16.6044 7.78807L16.6054 7.78707L12.7504 11.6421L8.89545 7.78707C8.68818 7.59691 8.41547 7.49416 8.13425 7.50026C7.85303 7.50635 7.58503 7.62083 7.38619 7.8198C7.18736 8.01876 7.07305 8.28683 7.06714 8.56806C7.06122 8.84928 7.16415 9.12193 7.35445 9.32907L7.35345 9.32807L11.2084 13.1831L7.35345 17.0381C7.24499 17.1376 7.15778 17.258 7.09708 17.3921C7.03638 17.5262 7.00345 17.6712 7.00026 17.8184C6.99707 17.9655 7.02369 18.1118 7.07852 18.2484C7.13334 18.385 7.21525 18.5091 7.3193 18.6132C7.42334 18.7173 7.54738 18.7993 7.68395 18.8542C7.82051 18.9091 7.96678 18.9359 8.11394 18.9328C8.2611 18.9297 8.40612 18.8968 8.54025 18.8362C8.67439 18.7756 8.79487 18.6885 8.89445 18.5801L8.89545 18.5791L12.7504 14.7241L16.6054 18.5791C16.705 18.6875 16.8254 18.7747 16.9595 18.8354C17.0936 18.8961 17.2386 18.9291 17.3857 18.9323C17.5329 18.9355 17.6792 18.9088 17.8158 18.854C17.9524 18.7992 18.0765 18.7173 18.1806 18.6132C18.2847 18.5092 18.3667 18.3851 18.4216 18.2486C18.4765 18.112 18.5032 17.9657 18.5001 17.8186C18.497 17.6714 18.4642 17.5264 18.4036 17.3923C18.343 17.2581 18.2558 17.1377 18.1474 17.0381L18.1464 17.0371L14.2914 13.1841Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1330_1615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.f498442c732f2037440e4aa835a088da.svg";
export { ForwardRef as ReactComponent };